import localforage from 'localforage'
import axios from 'axios'

export function saveToken (name, token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token.access_token.replace(/(^")|("$)/g, '')
  return localforage.setItem(name, token)
}

export function getToken (name) {
  return localforage.getItem(name)
}

export function saveUser (name, token) {
  return localforage.setItem(name, token)
}

export function getUser (name) {
  return localforage.getItem('user')
}

export function removeToken (name) {
  return localforage.removeItem(name)
}

export async function signOut () {
  await localforage.removeItem('token')
  return localforage.removeItem('user')
}

export async function isLogin () {
  try {
    const token = await localforage.getItem('token')
    return !!token
  } catch (error) {
    return error
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authService.js